<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tx5YFV/tc-custom/9781910859469.jpg?1705236026636" alt="This image is the cover for the book Manchester Slingback"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Manchester Slingback
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>A successful man confronts his hustler youth when an old friend is murdered in this crime novel exploring the gritty gay Village of ’80s Manchester.</b></p><p> At thirty-four years old, Jake Powell is a consummate professional in charge of an upscale casino in the West End of London. But fifteen years ago, Jake was hustling on the fringes of Manchester’s gay Village: running wild with a crowd of rentboys, purse-snatchers and disco trash; sleeping with anyone and everything. </p> In those days, Jake did a lot of things he’s not proud of. And what little he does remember he’d prefer to forget. But when Detective Inspector Davey Green takes a sudden and unexpected interest in his past, Jake is forced to confront the dirty secrets that led to the murder of his best friend . . . 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Nicholas Blincoe
      </h2>
      
      <p class="authorDescription body article"><P>Nicholas Blincoe is an author, critic and screenwriter. His many novels include the highly-acclaimed Manchester Slingback, which won the CWA Silver Dagger award in 1998. Born in Rochdale, he attended the University of Warwick, where he completed a PhD in contemporary European philosophy.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1621bb5a